import { Component, computed, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardDialogFramePart, DialogAction, DialogContext, DialogService } from '@eforall/dashboard';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { ReadonlyAccessWidget } from '../../readonly-access/readonly-access.widget';
import { MentorSignUpEditorDialog } from '../mentor-sign-up-editor/mentor-sign-up-editor.dialog';
import { VolunteerDialog } from '../volunteer-dialog';
import { MentorSignUpDetailsPart } from './details/details.part';
import { MentorSignUpViewerDialogDataService } from './mentor-sign-up-viewer-dialog-data.service';
import { MentorSignUpSchedulePart } from './schedule/schedule.part';
@Component({
	selector: 'programs-mentor-sign-up-viewer-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		ReadonlyAccessWidget,
		TabStripModule,
		MentorSignUpSchedulePart,
		MentorSignUpDetailsPart
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './mentor-sign-up-viewer.dialog.html',
})

export class MentorSignUpViewerDialog implements OnInit {

	public dialogRef = inject(MatDialogRef<MentorSignUpViewerDialog>);
	public dialogContext: DialogContext<{ volunteerSignupMentorId: number }> = inject(MAT_DIALOG_DATA);

	private readonly dialogService = inject(DialogService);
	public readonly dialogDataservice = inject(MentorSignUpViewerDialogDataService);
	public readonly headerTitle = computed(() => `Mentor Signup: ${this.dialogDataservice.mentorSignUpDetails()?.person.fullName}`)

	async ngOnInit() {
		const data = this.dialogContext.data;
		if (data) {
			await this.dialogDataservice.getVolunteerSignupMentorData(data.volunteerSignupMentorId);
		}
	}

	public actions = computed<DialogAction[]>(() => {
		const signUpDetails = this.dialogDataservice.mentorSignUpDetails();
		if (!signUpDetails) return [];

		return [{
			id: 'editSignUp',
			cssClass: signal('btn-standard'),
			enabled: signal(this.dialogDataservice.canEdit()),
			visible: signal(true),
			text: signal('Edit'),
			linkType: "callback",
			willCloseDialog: false,
			callback: async () => {
				await this.dialogService.showCustom(MentorSignUpEditorDialog, { data: signUpDetails }, 500, 500);
				await this.dialogDataservice.getVolunteerSignupMentorData(signUpDetails.volunteerSignupMentorId);
			}
		},
		{
			id: 'viewVolunteerDetails',
			cssClass: signal('btn-standard'),
			enabled: signal(true),
			visible: signal(true),
			text: signal('View Volunteer Details'),
			linkType: "callback",
			willCloseDialog: false,
			callback: async () => {
				await this.dialogService.showCustom(VolunteerDialog, { data: { volunteerId: signUpDetails.volunteerId } }, 900, 900);
				await this.dialogDataservice.getVolunteerSignupMentorData(signUpDetails.volunteerSignupMentorId);
			}
		},
		{
			id: 'close',
			cssClass: signal('undefined'),
			enabled: signal(true),
			visible: signal(true),
			text: signal('Close'),
			linkType: "no-action",
			willCloseDialog: true,
		}];
	});

}